import React, { Fragment } from "react"

const RestrictedHeadear = (title, subtitle) => {
  return (
    <Fragment>
      <h2 className="restricted__message__header">{title}</h2>
      <p className="restricted__message__subtitle">{subtitle}</p>
    </Fragment>
  )
}

export default RestrictedHeadear
